import { defineBlock } from "eddev/blocks"
import { Col, Container, Grid } from "@components/layout/Grid"
import { VSpace } from "@components/layout/Spacer"
import { Accordion } from "@components/molecules/Accordion"
import { useIsMobile } from "@hooks/useViewportDerived"

export const meta: BlockMeta = {
  title: "Accordion group",
  category: "common",
  icon: "arrow-down-alt2",
  keywords: ["accordion"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/accordion-group", (props) => {
  const isMobile = useIsMobile()

  return (
    <Container>
      <Grid>
        {!isMobile && !env.admin && <Col initial={12} tablet={1} laptop={2} />}
        <Col initial={12} tablet={env.admin ? 12 : 10} laptop={env.admin ? 12 : 8}>
          <VSpace initial={6} />
          {props.accordions?.map((accordion, i) => (
            <Accordion
              key={i}
              title={accordion?.title}
              content={
                accordion?.contentType === "paragraph" ? (
                  accordion?.content
                ) : (
                  <ul>{accordion?.list?.map((item, i) => <li key={i}>{item?.item}</li>)}</ul>
                )
              }
              emergency={accordion?.emergencyLink}
            />
          ))}
          <VSpace initial={6} />
        </Col>
      </Grid>
    </Container>
  )
})
